import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  AuthenticationService,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalContent,
  Toaster,
} from '@knockrentals/knock-react';
import { Formik } from 'formik';
import SourcesAPI from '../SourcesAPI';
import {
  greetingDelayOptions,
  greetingRepeatOptions,
} from '../PropertySources';
import { VALIDATION_ERROR_MESSAGES } from './constants';
import './_phoneRelayEditor.scss';

class SourceRelayPhoneEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applicantForwardingNumber: '',
      applicantGreetingDelaySeconds: 5,
      applicantGreetingRepeatCount: 0,
      forwardsTo: '',
      residentForwardsTo: '',
      sourceId: '',
      greetingRepeat: 0,
      residentGreetingRepeat: 0,
      greetingDelay: 5,
      residentGreetingDelay: 1,
      isSpamDetectionEnabled: null,
      recordCalls: true,
      relayPhoneNumber: null,
    };
  }

  componentDidMount() {
    const { source, relayPhone } = this.props;

    if (relayPhone.relayPhoneId) {
      this.setState({
        relayPhoneNumber: relayPhone.voiceNumberRaw,
        forwardsTo:
          relayPhone.voiceNumberForwardsToRaw?.length > 10
            ? relayPhone.voiceNumberForwardsToRaw.slice(-10)
            : relayPhone.voiceNumberForwardsToRaw,
        residentForwardsTo:
          relayPhone.voiceNumberResidentForwardsToRaw?.length > 10
            ? relayPhone.voiceNumberResidentForwardsToRaw.slice(-10)
            : relayPhone.voiceNumberResidentForwardsToRaw,
        applicantForwardingNumber:
          relayPhone.applicantForwardingNumberRaw?.length > 10
            ? relayPhone.applicantForwardingNumberRaw.slice(-10)
            : relayPhone.applicantForwardingNumberRaw,
        sourceId: source.id,
      });

      SourcesAPI.getRelaySettings(
        this.props.propertyId,
        relayPhone.relayPhoneId
      )
        .then((response) => {
          this.setState({
            applicantGreetingDelaySeconds:
              response.relay_phone.applicant_greeting_delay_seconds || 5,
            applicantGreetingRepeatCount:
              response.relay_phone.applicant_greeting_repeat_count || 0,
            recordCalls: response.relay_phone.should_record,
            greetingRepeat: response.relay_phone.greeting_repeat_count,
            residentGreetingRepeat:
              response.relay_phone.resident_greeting_repeat_count,
            greetingDelay: response.relay_phone.greeting_delay_seconds,
            residentGreetingDelay:
              response.relay_phone.resident_greeting_delay_seconds,
            isSpamDetectionEnabled:
              response.relay_phone.is_spam_detection_enabled,
          });
        })
        .catch(() => {
          Toaster.showToast(
            'Error loading relay phone settings',
            2000,
            Toaster.ToastClasses.error
          );
        });
    }
  }

  render() {
    const sourceOptions = this.props.sources
      .filter(
        (source) => !source.relayPhones || source.id === this.state.sourceId
      )
      .map((source) => {
        return (
          <option key={source.id} value={source.id}>
            {source.title}
          </option>
        );
      });

    return (
      <Modal className="phone-relay-editor">
        <Formik
          initialValues={{
            applicantForwardingNumber: this.state.applicantForwardingNumber,
            applicantGreetingDelaySeconds:
              this.state.applicantGreetingDelaySeconds,
            applicantGreetingRepeatCount:
              this.state.applicantGreetingRepeatCount,
            forwardsTo: this.state.forwardsTo,
            greetingRepeat: this.state.greetingRepeat,
            greetingDelay: this.state.greetingDelay,
            recordCalls: this.state.recordCalls,
            residentForwardsTo: this.state.residentForwardsTo,
            residentGreetingRepeat: this.state.residentGreetingRepeat,
            residentGreetingDelay: this.state.residentGreetingDelay,
            sourceId: this.state.sourceId,
            isSpamDetectionEnabled: this.state.isSpamDetectionEnabled,
            relayPhoneNumber: this.state.relayPhoneNumber,
          }}
          validate={this.validate}
          onSubmit={this.onSubmit.bind(this)}
          enableReinitialize
        >
          {(props) => (
            <form
              onSubmit={props.handleSubmit}
              onKeyPress={this.pressEnterSelectTrackingNumber.bind(this)}
              autoComplete="off"
            >
              <ModalHeader>
                <h3>Edit Tracking Number</h3>
              </ModalHeader>
              <ModalContent>
                <div>
                  <div className="knock-react-flex">
                    <div>
                      <strong>Tracking number:</strong>
                    </div>
                    <div>{this.state.relayPhoneNumber}</div>
                  </div>
                  <div className="knock-react-flex">
                    <div>
                      <strong>Source: </strong>
                    </div>
                    <div>
                      <select
                        name="sourceId"
                        value={props.values.sourceId}
                        onChange={props.handleChange}
                      >
                        {sourceOptions}
                      </select>
                    </div>
                  </div>
                  <div className="knock-react-flex">
                    <div>
                      <strong>Record calls: </strong>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        checked={!!props.values.recordCalls}
                        onChange={(e) =>
                          props.setFieldValue('recordCalls', e.target.checked)
                        }
                        name="recordCalls"
                      />
                    </div>
                  </div>
                  {AuthenticationService._internalMode && (
                    <div className="knock-react-flex">
                      <div>
                        <strong>Detect spam: </strong>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          checked={props.values.isSpamDetectionEnabled || false}
                          onChange={(e) =>
                            props.setFieldValue(
                              'isSpamDetectionEnabled',
                              e.target.checked
                            )
                          }
                          name="isSpamDetectionEnabled"
                        />
                      </div>
                    </div>
                  )}
                  <hr />
                  <div
                    className={classnames(
                      'knock-react-flex',
                      props.errors.forwardsTo && 'error'
                    )}
                  >
                    <div id="forwardsTo">
                      <strong>Prospect: </strong>
                    </div>
                    <div>
                      <input
                        aria-labelledby="forwardsTo"
                        className="knock-react-input"
                        value={props.values.forwardsTo}
                        name="forwardsTo"
                        placeholder="Phone number"
                        onChange={props.handleChange}
                      />
                      {!!props.errors.forwardsTo && (
                        <div className="knock-react-form-hint knock-react-form-hint-error">
                          {props.errors.forwardsTo}
                        </div>
                      )}
                    </div>
                  </div>
                  {AuthenticationService._internalMode && (
                    <Fragment>
                      <div className="knock-react-flex">
                        <div>
                          <strong>Greeting: </strong>
                        </div>
                        <div>
                          <select
                            value={props.values.greetingRepeat}
                            name="greetingRepeat"
                            onChange={props.handleChange}
                          >
                            {greetingRepeatOptions}
                          </select>
                        </div>
                      </div>
                      <div className="knock-react-flex">
                        <div>
                          <strong>Greeting delay: </strong>
                        </div>
                        <div>
                          <select
                            name="greetingDelay"
                            value={props.values.greetingDelay}
                            onChange={props.handleChange}
                          >
                            {greetingDelayOptions}
                          </select>
                        </div>
                      </div>
                    </Fragment>
                  )}
                  <hr />
                  <div
                    className={classnames(
                      'knock-react-flex',
                      props.errors.residentForwardsTo && 'error'
                    )}
                  >
                    <div id="residentForwardsTo">
                      <strong>Resident: </strong>
                    </div>
                    <div>
                      <input
                        aria-labelledby="residentForwardsTo"
                        className="knock-react-input"
                        value={props.values.residentForwardsTo}
                        name="residentForwardsTo"
                        placeholder="Phone number"
                        onChange={props.handleChange}
                      />
                      {!!props.errors.residentForwardsTo && (
                        <div className="knock-react-form-hint knock-react-form-hint-error">
                          {props.errors.residentForwardsTo}
                        </div>
                      )}
                    </div>
                  </div>
                  {AuthenticationService._internalMode && (
                    <Fragment>
                      <div className="knock-react-flex">
                        <div>
                          <strong>Greeting: </strong>
                        </div>
                        <div>
                          <select
                            name="residentGreetingRepeat"
                            value={props.values.residentGreetingRepeat}
                            onChange={props.handleChange}
                          >
                            {greetingRepeatOptions}
                          </select>
                        </div>
                      </div>
                      <div className="knock-react-flex">
                        <div>
                          <strong>Greeting delay: </strong>
                        </div>
                        <div>
                          <select
                            name="residentGreetingDelay"
                            value={props.values.residentGreetingDelay}
                            onChange={props.handleChange}
                          >
                            {greetingDelayOptions}
                          </select>
                        </div>
                      </div>
                    </Fragment>
                  )}
                </div>
                {this.props.isApplicantCallRoutingEnabled && (
                  <React.Fragment>
                    <hr />
                    <div
                      className={classnames(
                        'knock-react-flex',
                        props.errors.applicantForwardingNumber && 'error'
                      )}
                    >
                      <div id="applicantForwardingNumber">
                        <strong>Applicant: </strong>
                      </div>
                      <div>
                        <input
                          aria-labelledby="applicantForwardingNumber"
                          className="knock-react-input"
                          value={props.values.applicantForwardingNumber}
                          name="applicantForwardingNumber"
                          placeholder="Phone number"
                          onChange={props.handleChange}
                        />
                        {!!props.errors.applicantForwardingNumber && (
                          <div className="knock-react-form-hint knock-react-form-hint-error">
                            {props.errors.applicantForwardingNumber}
                          </div>
                        )}
                      </div>
                    </div>
                    {AuthenticationService._internalMode && (
                      <Fragment>
                        <div className="knock-react-flex">
                          <div>
                            <strong>Greeting: </strong>
                          </div>
                          <div>
                            <select
                              name="applicantGreetingRepeatCount"
                              value={props.values.applicantGreetingRepeatCount}
                              onChange={props.handleChange}
                            >
                              {greetingRepeatOptions}
                            </select>
                          </div>
                        </div>
                        <div className="knock-react-flex">
                          <div>
                            <strong>Greeting delay: </strong>
                          </div>
                          <div>
                            <select
                              name="applicantGreetingDelaySeconds"
                              value={props.values.applicantGreetingDelaySeconds}
                              onChange={props.handleChange}
                            >
                              {greetingDelayOptions}
                            </select>
                          </div>
                        </div>
                      </Fragment>
                    )}
                  </React.Fragment>
                )}
              </ModalContent>
              <ModalFooter>
                <button
                  className="knock-react-button"
                  onClick={this.props.onCancel}
                >
                  Cancel
                </button>
                <button
                  className="knock-react-button"
                  disabled={!props.isValid}
                  type="submit"
                >
                  Save
                </button>
              </ModalFooter>
            </form>
          )}
        </Formik>
      </Modal>
    );
  }

  //Prevent the enter key from bubbling up and closing the form or submitting invalid form data
  pressEnterSelectTrackingNumber(event, formProps) {
    if (event.charCode === 13) {
      event.stopPropagation();
      event.preventDefault();

      if (formProps.isValid) {
        formProps.handleSubmit();
      }
    }
  }

  onSubmit(values) {
    const replaceDigitsRegex = /\D/g;

    this.props.onSubmit({
      applicantForwardingNumber: values.applicantForwardingNumber,
      applicantGreetingDelaySeconds: Number(
        values.applicantGreetingDelaySeconds
      ),
      applicantGreetingRepeatCount: Number(values.applicantGreetingRepeatCount),
      forwardsTo: values.forwardsTo.replace(replaceDigitsRegex, ''),
      greetingDelay: Number(values.greetingDelay),
      greetingRepeat: Number(values.greetingRepeat),
      isSpamDetectionEnabled: values.isSpamDetectionEnabled,
      recordCalls: values.recordCalls,
      relayPhoneNumber: values.relayPhoneNumber,
      residentForwardsTo: values.residentForwardsTo.replace(
        replaceDigitsRegex,
        ''
      ),
      residentGreetingDelay: Number(values.residentGreetingDelay),
      residentGreetingRepeat: Number(values.residentGreetingRepeat),
      sourceId: Number(values.sourceId),
    });
  }

  validate = (values) => {
    const errors = {};
    const cleanRelayPhoneNumber = values.relayPhoneNumber.slice(-10);
    const cleanForwardsTo = values.forwardsTo.replace(/\D/g, '');
    const cleanResidentForwardsTo = values.residentForwardsTo.replace(
      /\D/g,
      ''
    );

    if (!cleanForwardsTo) {
      errors.forwardsTo = 'Required';
    }

    if (cleanForwardsTo.length !== 10) {
      errors.forwardsTo = 'Invalid phone number';
    }

    if (cleanForwardsTo === cleanRelayPhoneNumber) {
      errors.forwardsTo = VALIDATION_ERROR_MESSAGES.PROSPECT_SAME_AS_TRACKING;
    }

    if (!cleanResidentForwardsTo) {
      errors.residentForwardsTo = 'Required';
    }

    if (cleanResidentForwardsTo.length !== 10) {
      errors.residentForwardsTo = 'Invalid phone number';
    }

    if (cleanResidentForwardsTo === cleanRelayPhoneNumber) {
      errors.residentForwardsTo =
        VALIDATION_ERROR_MESSAGES.RESIDENT_SAME_AS_TRACKING;
    }

    if (!values.sourceId) {
      errors.sourceId = 'Required';
    }

    if (this.props.isApplicantCallRoutingEnabled) {
      const cleanApplicantNumber = values.applicantForwardingNumber.replace(
        /\D/g,
        ''
      );

      if (cleanApplicantNumber.length !== 10) {
        errors.applicantForwardingNumber = 'Invalid phone number';
      }

      if (cleanApplicantNumber === cleanRelayPhoneNumber) {
        errors.applicantForwardingNumber =
          VALIDATION_ERROR_MESSAGES.APPLICANT_SAME_AS_TRACKING;
      }
    }

    return errors;
  };
}

SourceRelayPhoneEditor.propTypes = {
  isApplicantCallRoutingEnabled: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  propertyId: PropTypes.number,
  relayPhone: PropTypes.shape({
    applicantForwardingNumber: PropTypes.string,
    applicantForwardingNumberRaw: PropTypes.string,
    relayPhoneId: PropTypes.number,
    voiceNumberRaw: PropTypes.string,
    voiceNumberForwardsToRaw: PropTypes.string,
    voiceNumberResidentForwardsToRaw: PropTypes.string,
  }),
  source: PropTypes.shape({ id: PropTypes.number }),
  sources: PropTypes.arrayOf(PropTypes.shape({})),
};

export default SourceRelayPhoneEditor;
